//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mutations } from "@/observable/store";
import { CacheModule } from "@/utils/commonUtils";
import { installmentLogin } from "@/model/javaApi/detail.js";
export default {
  name: "transition",
  data() {
    return {
      yfbInsuranceUniqueId: "",
      params: {},
    };
  },
  created() {
    this.yfbInsuranceUniqueId = this.$route.query.yfbInsuranceUniqueId || "";
    if (this.yfbInsuranceUniqueId) {
      this.getQueryParams();
      this.getUserInfo();
    }
  },
  methods: {
    // 获取路由中参数
    getQueryParams() {
      for (let key in this.$route.query) {
        this.params[key] = this.$route.query[key];
      }
    },
    getUserInfo() {
      installmentLogin({
        yfbInsuranceUniqueId: this.yfbInsuranceUniqueId,
      })
        .then((res) => {
          mutations.getsyToken(res.token);
          mutations.getUid(res.uid);
          mutations.getPhone(res.phone);

          let userInfo = {
            login_token: res.token,
            login_uid: res.uid,
            login_phone: res.phone,
            login_insure_uid: res.insure_uid,
          };
          CacheModule.set("userInfo", userInfo);

          setTimeout(() => {
            this.$router.push({
              path: "/stencilInstallment",
              query: this.params,
            });
          }, 2000);
        })
        .catch(() => {});
    },
  },
};
